<div *ngIf="!noData; else no_data">
    <div class="mat-typography content">
        <p>Zoning code records (GAPI): {{ metaData?.gapiPRsCount?.total | number }} </p>
        <p>Cached property records (ZAPI): {{ metaData?.cachedPRs?.total | number }}</p>
        <p>Property records left: {{ metaData?.notCachedPRsCount?.total | number }}</p>
        <p>Progress: {{ metaData?.prsCachingProgress?.total }}%</p>
    </div>
</div>

<ng-template #no_data>
    <div class="mat-typography content">
        <p>No data </p>
    </div>
</ng-template>